// extracted by mini-css-extract-plugin
module.exports = {"Countries":"Countries_Countries__36FQM"};